import { Injectable } from '@angular/core';
import { TranslateService, LangChangeEvent } from '@ngx-translate/core';
import { Subject } from 'rxjs';
import { LocalStorageService } from '../localStorage/localStorage.service';
import { localStorageKeys } from '../localStorage/localStorageVariables';
import { PageStateService } from '../page-state.service';
@Injectable({
  providedIn: 'root',
})
export class I18ConfigService {
  public selectedLanguage = new Subject<string>();

  constructor(
    private translate: TranslateService,
    private localStorageData: LocalStorageService,
    private pageStateService: PageStateService
  ) {
    if (this.localStorageData.getItem(localStorageKeys.LANGUAGE)) {
      this.selectedLanguage.next(
        this.localStorageData.getItem(localStorageKeys.LANGUAGE)
      );
    }
    this.translate.onLangChange.subscribe((event: LangChangeEvent) => {
      this.selectedLanguage.next(event.lang);
    });
  }
  get language() {
    return this.localStorageData.getItem(localStorageKeys.LANGUAGE);
  }
  set language(lang: string) {
    this.localStorageData.setItem(localStorageKeys.LANGUAGE, lang);
  }
  getDefaultLanguage() {
    const language = this.translate.getBrowserLang();
    this.translate.setDefaultLang(language);
    this.selectedLanguage.next(language);
    return language;
  }
  getLanguage() {
    const finalLang = this.getAvailableLang(
      this.localStorageData.getItem(localStorageKeys.LANGUAGE) || 'en'
    );
    return finalLang;
  }
  setLanguage(lang) {
    const finalLang = this.getAvailableLang(lang);
    this.translate.use(finalLang);
    this.localStorageData.setItem(localStorageKeys.LANGUAGE, finalLang);
    this.translate.reloadLang(finalLang);
    const appDirection = document.getElementById('app-direction');
    if (finalLang === 'ar') {
      appDirection.style.direction = 'rtl';
    } else {
      if (appDirection.classList.value.includes('app-direction-rtl')) {
        appDirection.classList.remove('app-direction-rtl');
      } else {
        appDirection.style.direction = 'ltr';
      }
    }
  }
  setDefaultLanguage(lang) {
    const finalLang = this.getAvailableLang(lang);
    this.translate.use(finalLang);
  }
  getAvailableLang(lang) {
    const availableLang = ['en', 'de', 'ar'];
    const isavailable = availableLang.includes(lang);
    if (isavailable) {
      return lang;
    } else {
      return 'en';
    }
  }
  hasCurrency(): boolean {
    return !!this.localStorageData.getItem(localStorageKeys.CURRENCY);
  }
  getCurrency(): string | undefined {
    return this.localStorageData.getItem(localStorageKeys.CURRENCY) || 'INR';
  }
  setCurrency(currencyCode) {
    this.localStorageData.setItem(localStorageKeys.CURRENCY, currencyCode);
    this.pageStateService.setReloadAll()
  }
}
